export const books = [
  {
    number: '01',
    title: "Devil's Due",
    series: 'The Veilborn Chronicles',
    description: "In rain-slicked Seattle, monster-hunting brothers Keenan and Rory Sullivan uncover a slaughterhouse of Lust vampires and a terrified ten-year-old boy with a dangerous secret. When Rory is jailed after confronting the boy's possessed father, he must ignite a prison riot while Keenan joins forces with a fiery djinn to search underground Seattle for an ancient dragon egg before a hellhound and shadow demon tear the city apart. Packed with lethal creatures, dark sorcery, and brotherly grit, Devil's Due is an explosive urban fantasy thriller about saving one innocent boy—and keeping Seattle from becoming hell on earth.",
    quote: 'The city remembers every spell cast in its streets.',
    tags: ['Blood Magic', 'Occult Mystery', 'Found Family'],
    image: 'https://cloud.sharemyimage.com/2026/09/23/Emily_Devils_Due.png',
    color: '#bf7c3f'
  },
  {
    number: '02',
    title: 'Marked For Nothing',
    series: 'The Marked Saga',
    description: "Wyatt Mercer is twenty-four, works the graveyard shift at a Kwik-Stop in Magnolia, Texas, and just wants to be left alone. Then a blast of raw magic marks him UNCLAIMED and bonds him to four pieces of junk from his own pockets: a box cutter, a cracked phone, an expired bus pass, and a pair of cowboy boots.\n\nNow he has nine days to learn how to fight, lead, and care before corporate developer Adrienne Voss claims the ley-line beneath his neighborhood and erases everyone on it.\n\nWith his stray dog Dusty, a burned-out magical fixer, his best friend, and his paralegal mother fighting the paperwork, Wyatt must become the protector he never planned to be.",
    quote: 'Every claim has a cost.',
    tags: ['Magical Property Rights', 'Urban Fantasy', 'Hidden War'],
    image: 'https://cloud.sharemyimage.com/2026/09/23/MarkedforNothing.png',
    color: '#8f70c7'
  }
];

/*
  Characters: set `image` to a photo URL for each character.
  Characters with an empty `image` show an elegant monogram
  placeholder until a photo is added.
  Row 1 = protagonists, Row 2 = antagonists.
*/
export const characters = [
  {
    name: 'Wyatt Mercer',
    role: 'The Unclaimed',
    description: 'A deadpan graveyard clerk who wants to be left alone. Four pieces of pocket junk and nine days say otherwise.',
    image: 'https://cloud.sharemyimage.com/2026/09/25/_Urban-fantasy--1.webp',
    symbol: 'THE PROTAGONIST'
  },
  {
    name: 'Dusty',
    role: 'True Companion',
    description: 'A stray who was never claimed, only chosen. He senses magic no one else can, and he matters more than anyone realizes.',
    image: 'https://cloud.sharemyimage.com/2026/09/25/Dusty-gpt-image2-2.webp',
    symbol: 'THE COMPANION'
  },
  {
    name: 'Ressa',
    role: 'The Fixer',
    description: 'A world-weary fixer bound by magical contract. The darker her eyes grow at the edges, the more of herself she has spent.',
    image: 'https://cloud.sharemyimage.com/2026/09/25/Ressa-1.webp',
    symbol: 'THE FIXER'
  },
  {
    name: 'Adrienne Voss',
    role: 'The Developer',
    description: "The polished CEO of Voss-Kline Development. She has a plan for Magnolia's land and no interest in asking permission.",
    image: 'https://cloud.sharemyimage.com/2026/09/25/Voss-1.webp',
    symbol: 'THE ANTAGONIST'
  },
  {
    name: 'Silas Crane',
    role: "Voss's Enforcer",
    description: 'His eyes are blacked out by total surrender to his Claim. Dusty left a scar across his face that he can never hide.',
    image: 'https://cloud.sharemyimage.com/2026/09/25/Silas-1.webp',
    symbol: 'THE ENFORCER'
  },
  {
    name: 'Husk',
    role: 'The Broken-Claimed',
    description: 'Once claimed, then violently severed. Some still speak and wear a human face until pain cracks it. The rest are pure hunger, hunting every spark of magic they can sense.',
    image: 'https://cloud.sharemyimage.com/2026/10/04/00015-586146314.png',
    symbol: 'THE FERAL'
  }
];
